import { useMemo } from 'react';
import hierarchies from '../../data/stellenmarkt_hierarchies.json';

const useGetFlatHierachie = () => {
  const flatHierachies = useMemo(() => {
    const transformHierarchies = (
      node: any,
      parentPath = '',
    ): { path: string; name: string }[] => {
      if (!node.id) {
        return [];
      }
      const currentPath = parentPath ? `${parentPath}-${node.id}` : node.id;
      const result: { path: string; name: string }[] = [
        {
          path: currentPath,
          name: node.name,
        },
      ];

      if (node.children && node.children.length > 0) {
        node.children.forEach((child: any) => {
          result.push(...transformHierarchies(child, currentPath));
        });
      }
      return result;
    };

    // remove first entry, because it's the root node
    const result = transformHierarchies(hierarchies);
    result.shift();
    return result;
  }, [hierarchies]);

  return flatHierachies;
};

export default useGetFlatHierachie;
